module.exports = __webpack_public_path__ + "220738096ba5064da9242ef74aabff28.svg";